// Wraps each heading + its next short sibling in a break-inside:avoid div to
// prevent orphaned headings at page breaks. Browsers don't reliably honor
// break-after:avoid on headings in print, so the wrapper is the dependable
// approach. Operates on the print iframe's document.

// Max height of a heading's next sibling for them to be kept together. A taller
// sibling creates a large break-inside:avoid block that gets pushed to the next
// page, leaving a blank gap on the prior page — so above this we don't wrap.
const MAX_KEEP_WITH_NEXT_HEIGHT_PX = 400;

export function wrapHeadingsWithNextSibling(doc: Document): void {
  // Skip headings inside our injected PDF header elements — wrapping those
  // breaks the flex layout of the header card.
  const pdfHeaderEls = new Set(
    Array.from(
      doc.querySelectorAll(
        '.pdf-top, .pdf-info-header, .pdf-top *, .pdf-info-header *'
      )
    )
  );
  doc.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
    if (pdfHeaderEls.has(heading)) return;
    const next = heading.nextElementSibling;
    // Only wrap when the sibling is short enough to fit with the heading on
    // one page (see MAX_KEEP_WITH_NEXT_HEIGHT_PX).
    if (
      next &&
      ['P', 'UL', 'OL'].includes(next.tagName) &&
      next.getBoundingClientRect().height <= MAX_KEEP_WITH_NEXT_HEIGHT_PX
    ) {
      const wrapper = doc.createElement('div');
      wrapper.className = 'pdf-keep-with-next';
      heading.parentNode?.insertBefore(wrapper, heading);
      wrapper.appendChild(heading);
      wrapper.appendChild(next);
    }
  });
}
